<template>


    <section> 
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/springer.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  
                    <h1>
                            Thank you
                        </h1>
                        
                        <strong>Thank you for submitting your art to us. We will review your application and will get back to you shortly. In the meantime feel free to browse through our catalogue for inspiration.<br><br><a href="https://shop.snap-collective.com">https://shop.snap-collective.com</a></strong>
                    
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
    
    
    
    
    
    </template>
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap10',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
            if (
                this.currentSnapWizard.images_ready == 1
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        show_images_hint() {
            if(this.currentSnapWizard.images_ready == 1 || this.currentSnapWizard.images_ready == undefined){
                return true;
            }
            else{
                return false;
            }
        },
        show_sorry() {
            if(this.currentSnapWizard.images_ready == 0 || this.currentSnapWizard.images_ready == "" ){
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
               // this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
       // this.allDataValidated();
    }
};
</script>